import { selectUserProps } from 'services/events/selectors'
import { selectLoggedIn } from 'services/user/selectors'
import { selectPathname } from 'services/routing/selectors'
import { EventTypes } from '@uacf/web-client-events'

export default function configureActionListeners (store, apis) {
  store.addActionListener('INIT', () => {
    const state = store.getState()
    const props = selectUserProps(state)

    const userProps = {
      app_name: props.app_name,
      platform: props.platform,
      domain: 'mmf',
    }

    if (props.user_id) {
      Object.assign(userProps, {
        age_group: props.age_group,
        user_id: props.user_id,
        city: props.user_city,
        country_code: props.user_country,
      })
    }

    apis.clientEventManager.updateUserProperties(userProps)
    apis.clientEventManager.logEvent(EventTypes.__INIT__)
  })

  store.addActionListener('@@router/UPDATE_LOCATION', () => {
    const state = store.getState()
    const pageName = selectPathname(state)
    const loginStatus = selectLoggedIn(state)

    const eventProps = {
      page_name: pageName,
      login_status: loginStatus,
    }

    apis.clientEventManager.logEvent('page_viewed', eventProps)
  })

  store.addActionListener('INITIATE_COUNTRY_CONFIRMATION', (action) => {
    const eventProps = {
      screen_name: 'privacy_center_region',
      country_selected: action.payload,
    }

    apis.clientEventManager.logEvent('edit_location_tapped', eventProps)
  })

  store.addActionListener('DEACTIVATE_USER_SUCCESS', () => {
    const state = store.getState()
    const entryPoint = state.consents.stagedScreenName
    const appName = state.site.name
    const eventProps = {
      screen_name: 'delete_account',
      app_name: appName,
      entry_point: entryPoint,
    }

    apis.clientEventManager.logEvent('account_deleted', eventProps)
  })
}



// WEBPACK FOOTER //
// ./src/shared/events/actionListeners.js